import { useContext } from 'react';
import { useRouter } from 'next/router';
import { DictionaryContext } from 'application/adapters/context/Dictionary';

/**
 * Custom hook to synchronize dictionary culture with current locale.
 * Updates dictionary culture before any dictionary getValue calls.
 *
 * @param culture - Optional fallback culture (e.g., from server-side props)
 * @returns Current locale (router.locale or fallback)
 */
export const useDictionaryLocale = (culture?: string): string => {
	const dictionary = useContext(DictionaryContext);
	const router = useRouter();

	// Use router.locale if available (client-side navigation), fallback to culture prop (server-side)
	const currentLocale = router.locale || culture || 'en';

	// Update dictionary culture synchronously before any dictionary calls
	if (dictionary && currentLocale && dictionary.culture !== currentLocale) {
		dictionary.culture = currentLocale;
	}

	return currentLocale;
};
